// Documentação do arquivo - Atualização 25/04/2025::
// Este arquivo contém a implementação do AuthInterceptor, que é um interceptor de requisições HTTP.
// Ele adiciona o token de autenticação ao cabeçalho das requisições HTTP. Se a requisição falhar com um erro 401,
// o token é removido do armazenamento local e o usuário é redirecionado para a página de login.

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const router = inject(Router);
  const isAuthRequest = req.url.includes('/auth/login') || req.url.includes('/auth/LoginSSO');

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    tap({
      error: (err) => {
        if (err.status === 401 && !isAuthRequest) {
          if (!window.location.pathname.startsWith('/auth')) {
            router.navigate(['/auth/login']);
          }
          localStorage.removeItem('token');
        }
      }
    })
  );
};
